import { useState } from 'react'
import { LinesList } from '@/components/LinesList'
import { NearbyMap } from '@/components/NearbyMap'
import { useAppState } from '@/components/AppLayout'

type TabView = 'lines' | 'nearby'

export function LinesPage() {
  const { lang, t } = useAppState()
  const [activeTab, setActiveTab] = useState<TabView>('lines')

  return (
    <div className="lines-page">
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <button
          className={`tab-button ${activeTab === 'lines' ? 'active' : ''}`}
          onClick={() => setActiveTab('lines')}
        >
          {t.linesTab}
        </button>
        <button
          className={`tab-button ${activeTab === 'nearby' ? 'active' : ''}`}
          onClick={() => setActiveTab('nearby')}
        >
          {t.nearbyTab}
        </button>
      </div>

      {/* Lines Tab Content */}
      {activeTab === 'lines' && (
        <LinesList
          lang={lang}
          translations={{
            searchPlaceholder: t.searchPlaceholder,
            favorites: t.favorites,
            allLines: t.allLines,
            loading: t.loading
          }}
        />
      )}

      {/* Nearby Map Tab Content */}
      {activeTab === 'nearby' && (
        <NearbyMap
          lang={lang}
          translations={{
            loading: t.loading,
            locationError: t.locationError,
            enableLocation: t.enableLocation,
            nearbyStops: t.nearbyStops,
            metersAway: t.metersAway,
            noStopsNearby: t.noStopsNearby
          }}
        />
      )}
    </div>
  )
}